import ServiceBusController from "servicestack/service-bus.controller";
import labels from "emun.media/_labels";
import Media from "emun.media/media.model";

export default class MediaPromptController extends ServiceBusController {
  constructor($uibModalInstance, options) {
    super();
    const $ctrl = this;
    $ctrl.modal = $ctrl.$uibModalInstance = $uibModalInstance;
    $ctrl.$dismiss = $uibModalInstance.dismiss;
    $ctrl.$close = $uibModalInstance.close;
Object.assign($ctrl, options);
    console.debug("MediaPromptController", { $ctrl, options });
    $ctrl.labels = labels;
    if ($ctrl.media.id) {
      $ctrl.bus.read("QueryMedia.json", { id: $ctrl.media.id }).then(
        ({
          data: {
            results: [m],
          },
        }) => $ctrl.initMedia($ctrl.media, m)
      );
    } else {
      $ctrl.initMedia($ctrl.media);
    }
  }

  initMedia(...items) {
    const $ctrl = this;
    $ctrl.media = new Media(
      Object.assign({ tags: { ...labels.defaultTags } }, ...items)
    );
    for (const tk in labels.defaultTags) {
      if (!(tk in $ctrl.media)) {
        $ctrl.media.tags[tk] = labels.defaultTags[tk];
      }
    }
    console.debug("initMedia", $ctrl.media);
  }

  $onInit() {
    const $ctrl = this;
  }

  submit() {
    const $ctrl = this;
    delete $ctrl.media.attributes;
    $ctrl.$close({
      $update: $ctrl.media,
      $file: $ctrl.$file,
    });
  }

  addTag() {
    const $ctrl = this;
    if ($ctrl.newTagKind) {
      if (!$ctrl.media.tags) {
        $ctrl.media.tags = {};
      }
      $ctrl.media.tags[$ctrl.newTagKind] = [];
      delete $ctrl.newTagKind;
    }
  }

  changeMedia($files) {
    const $ctrl = this;

    for (const $file of $files) {
      $ctrl.$file = $file;
      $ctrl.media.width = $file.$ngfWidth;
      $ctrl.media.height = $file.$ngfHeight;
      $ctrl.media.attributes = {
        ...$ctrl.media.attributes,
        width: $file.$ngfWidth,
        height: $file.$ngfHeight,
        ...$file,
      };
      $ctrl.media.mediaId = $file.name;
    }
  }
}
